import type{CharacterDNAContribution,CharacterDNAPatch}from'./characterDNA'

const CORE_CHARACTER_DNA_CONTRIBUTIONS:readonly CharacterDNAContribution[]=[
 {
  id:'core-vaelthar-v1',source:'independent-aetherborn-authorship',fighterId:'vaelthar-astral-architect',priority:100,
  patch:{
   lineage:'celestial',bodyPlan:'humanoid',archetype:'controller',
   physiology:{balance:.88,energyEfficiency:.95,neuralSpeed:.86,structuralStability:.76},
   senses:{vision:.91,energeticSense:.99,spatialSense:.98,proprioception:.87},
   mind:{discipline:.91,caution:.83,patience:.92,creativity:.96,prediction:.94,precision:.96,
    drives:{protection:.95,curiosity:.99,mastery:.97,restraint:.98,dominance:.11},
    architecture:{selfModel:.95,volition:.99,workingMemory:.94,planning:.97,metacognition:.96,
     socialCognition:.86,goalPersistence:.94,impulseControl:.95,emotionalIntegration:.84,
     episodicMemory:.98,semanticMemory:.97,imagination:.99,causalReasoning:.95,
     spatialReasoning:.99,temporalReasoning:.96,theoryOfMind:.86,sensorFusion:.98}},
   combat:{preferredRange:.93,environmentUse:.97,specialBias:.98,resourceConservation:.89,retreatDiscipline:.91},
   power:{source:'arcane',control:.98,precision:.98,channeling:.99,volatility:.22,
    quantumVacuum:{coupling:.92,coherence:.94,stability:.91,phaseControl:.92,shielding:.87,perception:.97}},
   expression:{grace:.92,aura:.99,secondaryMotion:.98,cameraPresence:.94},
   learning:{memoryDepth:.99,learningRate:.95,forgettingRate:.05,opponentSpecificity:.84,adaptationCeiling:.97},
   capabilities:{flight:false,quantum:true,transformation:false,regeneration:false,
    environmentManipulation:true,attacks:{light:.88,heavy:.85,special:1,throw:.59}},
   links:{modelAssetId:'vaelthar-astral-architect',sourceRegistry:'portal-battle-arena/HeroRegistry'}
  }
 },

 {
  id:'core-elyon-v1',source:'fight-core-authorship',fighterId:'elyon-protagonist',priority:100,
  patch:{
   archetype:'duelist',
   mind:{discipline:.86,prediction:.82,precision:.9,adaptability:.84,drives:{mastery:.92,restraint:.72},architecture:{selfModel:.94,volition:.95,workingMemory:.9,planning:.91,metacognition:.9,socialCognition:.82,goalPersistence:.96,impulseControl:.86,emotionalIntegration:.88}},
   combat:{tempo:.82,counterBias:.78,comboPersistence:.86,finisherDiscipline:.83,pursuit:.76},
   power:{source:'rift',control:.91,precision:.9,channeling:.82,volatility:.36,quantumVacuum:{coupling:.88,coherence:.91,stability:.9,extraction:.82,phaseControl:.94,entropyTolerance:.86,shielding:.83,perception:.92}},
   expression:{grace:.84,motionWeight:.46,cadence:.8,telegraph:.43,cameraPresence:.82},
   learning:{learningRate:.86,opponentSpecificity:.82,adaptationCeiling:.94},
   capabilities:{quantum:true,attacks:{light:.94,heavy:.86,special:.96,throw:.76}},
  }
 },
 {
  id:'core-vulcao-v1',source:'fight-core-authorship',fighterId:'guardian-vulcao',priority:100,
  patch:{
   archetype:'bruiser',
   physiology:{mass:.84,durability:.88,structuralStability:.9,neuralSpeed:.57},
   mind:{aggression:.78,courage:.88,discipline:.7,drives:{protection:.84,dominance:.8},architecture:{selfModel:.8,volition:.9,workingMemory:.7,planning:.68,metacognition:.64,socialCognition:.7,goalPersistence:.91,impulseControl:.56,emotionalIntegration:.7}},
   combat:{pressure:.9,guardBias:.74,environmentUse:.88,retreatDiscipline:.3},
   power:{source:'elemental',amplitude:.92,environmentCoupling:.95,area:.86,control:.62,volatility:.76},
   expression:{motionWeight:.88,ferocity:.9,aura:.92,audioPresence:.9,cadence:.48},
   capabilities:{environmentManipulation:true,attacks:{heavy:.97,special:.95,throw:.83}},
  }
 },
 {
  id:'core-crystal-dragon-v1',source:'fight-core-authorship',fighterId:'dragao-cristal',priority:100,
  patch:{
   archetype:'aerial',bodyPlan:'flying',
   physiology:{balance:.92,structuralStability:.88,reach:.86},
   senses:{vision:.9,vestibular:.96,spatialSense:.95,energeticSense:.88},
   mind:{aeriality:.98,precision:.84,prediction:.8,drives:{mastery:.82,curiosity:.68},architecture:{selfModel:.86,volition:.9,workingMemory:.82,planning:.8,metacognition:.78,socialCognition:.62,goalPersistence:.88,impulseControl:.72,emotionalIntegration:.82}},
   combat:{aerialMastery:.98,preferredRange:.74,pursuit:.82,environmentUse:.79},
   power:{source:'crystal',precision:.94,control:.89,area:.78,environmentCoupling:.76},
   expression:{grace:.86,secondaryMotion:.94,aura:.9,cameraPresence:.88},
   capabilities:{flight:true,environmentManipulation:true,attacks:{special:.94,heavy:.84}},
  }
 },
 {
  id:'core-phoenix-v1',source:'fight-core-authorship',fighterId:'fenix-primordial',priority:100,
  patch:{
   archetype:'aerial',bodyPlan:'flying',
   physiology:{regeneration:.97,balance:.94,energyEfficiency:.91,elasticity:.86},
   senses:{vestibular:.98,spatialSense:.94,energeticSense:.95},
   mind:{aeriality:.99,courage:.92,creativity:.86,adaptability:.88,drives:{survival:.78,mastery:.88},architecture:{selfModel:.91,volition:.96,workingMemory:.8,planning:.72,metacognition:.83,socialCognition:.74,goalPersistence:.94,impulseControl:.64,emotionalIntegration:.93}},
   combat:{aerialMastery:.99,tempo:.9,pursuit:.9,finisherDiscipline:.78},
   power:{source:'elemental',amplitude:.94,recovery:.96,transformation:.9,environmentCoupling:.88},
   expression:{grace:.9,ferocity:.84,aura:.98,secondaryMotion:.98,cameraPresence:.94},
   capabilities:{flight:true,transformation:true,regeneration:true,environmentManipulation:true,attacks:{light:.9,special:.98}},
  }
 },
 {
  id:'core-golem-v1',source:'fight-core-authorship',fighterId:'golem-vivo',priority:100,
  patch:{
   bodyPlan:'synthetic-organic',archetype:'colossus',
   physiology:{mass:.94,durability:.96,structuralStability:.98,neuralSpeed:.4,regeneration:.62},
   senses:{proprioception:.86,tactile:.9,painSensitivity:.24,interoception:.66},
   mind:{discipline:.78,patience:.84,caution:.7,aeriality:.08,drives:{protection:.9,restraint:.76},architecture:{selfModel:.76,volition:.84,workingMemory:.72,planning:.78,metacognition:.7,socialCognition:.58,goalPersistence:.96,impulseControl:.9,emotionalIntegration:.66}},
   combat:{pressure:.82,guardBias:.91,counterBias:.74,tempo:.35,resourceConservation:.88},
   expression:{motionWeight:.98,cadence:.3,ferocity:.68,telegraph:.82,audioPresence:.86},
   capabilities:{flight:false,attacks:{heavy:.99,throw:.93,special:.82}},
  }
 },
 {
  id:'core-titan-v1',source:'fight-core-authorship',fighterId:'tita-montanhas',priority:100,
  patch:{
   bodyPlan:'colossus',archetype:'colossus',
   physiology:{stature:1,mass:1,reach:.98,durability:.99,structuralStability:1,neuralSpeed:.34},
   senses:{spatialSense:.76,proprioception:.88,vestibular:.72,painSensitivity:.3},
   mind:{patience:.9,courage:.96,discipline:.82,aeriality:.02,drives:{dominance:.91,protection:.8},architecture:{selfModel:.9,volition:.98,workingMemory:.74,planning:.76,metacognition:.78,socialCognition:.64,goalPersistence:.99,impulseControl:.88,emotionalIntegration:.82}},
   combat:{preferredRange:.78,pressure:.96,guardBias:.86,throwBias:.94,tempo:.24,pursuit:.54},
   expression:{motionWeight:1,cadence:.2,ferocity:.86,telegraph:.92,cameraPresence:1,audioPresence:.98},
   capabilities:{flight:false,attacks:{heavy:1,throw:.98,special:.9}},
  }
 },
 {
  id:'core-quantum-archmage-v1',source:'fight-core-authorship',fighterId:'quantum-archmage',priority:100,
  patch:{
   archetype:'controller',
   senses:{energeticSense:.96,electromagneticSense:.94,spatialSense:.9},
   mind:{prediction:.92,creativity:.9,discipline:.84,architecture:{temporalReasoning:.97,causalReasoning:.92,workingMemory:.9,planning:.92,metacognition:.91,sensorFusion:.93}},
   combat:{preferredRange:.86,environmentUse:.94,specialBias:.96,resourceConservation:.82,counterBias:.82},
   power:{source:'temporal',control:.96,precision:.94,channeling:.93,volatility:.48,quantumVacuum:{coupling:.96,coherence:.97,stability:.9,extraction:.95,phaseControl:.96,entropyTolerance:.94,shielding:.86,perception:.98}},
   expression:{aura:.95,telegraph:.62,cameraPresence:.9,audioPresence:.86},
   capabilities:{quantum:true,environmentManipulation:true,attacks:{special:.99,light:.8,heavy:.72,throw:.58}},
  }
 },
 {
  id:'core-timekeeper-v1',source:'fight-core-authorship',fighterId:'timekeeper',priority:100,
  patch:{
   archetype:'controller',
   senses:{energeticSense:.92,electromagneticSense:.88,spatialSense:.9},
   mind:{prediction:.98,patience:.91,discipline:.9,architecture:{temporalReasoning:.99,causalReasoning:.94,planning:.96,workingMemory:.91,metacognition:.94,impulseControl:.9,sensorFusion:.9}},
   combat:{counterBias:.92,resourceConservation:.92,environmentUse:.91,retreatDiscipline:.87,specialBias:.95},
   power:{source:'temporal',control:.98,precision:.95,channeling:.94,volatility:.24,quantumVacuum:{coupling:.9,coherence:.99,stability:.97,extraction:.78,phaseControl:.95,entropyTolerance:.98,shielding:.91,perception:.97}},
   expression:{restraint:.9,telegraph:.7,aura:.88,cadence:.56},
   capabilities:{quantum:true,environmentManipulation:true,attacks:{special:.97,light:.74,heavy:.66,throw:.5}},
  }
 },
 {
  id:'core-rift-weaver-v1',source:'fight-core-authorship',fighterId:'rift-weaver',priority:100,
  patch:{
   archetype:'controller',
   senses:{energeticSense:.95,electromagneticSense:.9,spatialSense:.92},
   mind:{prediction:.9,creativity:.94,adaptability:.92,architecture:{causalReasoning:.92,spatialReasoning:.94,temporalReasoning:.88,planning:.89,imagination:.96,sensorFusion:.95}},
   combat:{environmentUse:.98,specialBias:.97,feintBias:.87,counterBias:.85,preferredRange:.82},
   power:{source:'rift',control:.93,precision:.9,channeling:.96,volatility:.67,environmentCoupling:.96,quantumVacuum:{coupling:.99,coherence:.88,stability:.79,extraction:.9,phaseControl:.92,entropyTolerance:.82,shielding:.74,perception:.95}},
   expression:{aura:.96,asymmetry:.78,secondaryMotion:.88,cameraPresence:.88},
   capabilities:{quantum:true,environmentManipulation:true,attacks:{special:.99,light:.76,heavy:.7,throw:.58}},
  }
 },
] as const

const BATTLE_ARENA_IDENTITY_SOURCE='inyron/Inyron@3ff78139118b4d2dd15a7c43749acae9ada592bd'
const BATTLE_ARENA_IDENTITY_ROWS=[
 ['iron-bulwark',null,'melee-chain','shockwave','iron-bulwark'],
 ['plague-harbinger',null,'projectile','plague-burst','plague-harbinger'],
 ['echo-dancer',null,'burst-melee','echo-chain','echo-dancer'],
 ['guardian-knight',null,'melee-chain','dash-strike','guardian-knight-v2'],
 ['arcane-mage',null,'projectile','phase-shift','arcane-mage'],
 ['cyber-vanguard',null,'melee-chain','blink','cyber-vanguard'],
 ['dragon-summoner',null,'projectile','summon','dragon-summoner'],
 ['reaper-executioner',null,'melee-chain','death-mark','reaper-executioner'],
 ['revenant',null,'burst-melee','phase-shift','revenant'],
 ['rift-weaver',null,'projectile','rift-anchor','rift-weaver'],
 ['tidal-warden',null,'melee-chain','stance-shift','tidal-warden'],
 ['timekeeper',null,'projectile','time-anchor','timekeeper'],
 ['void-seraph',null,'burst-melee','phase-shift','void-seraph'],
 ['shadow-assassin',null,'burst-melee','blink','shadow-assassin'],
 ['elysama',null,'melee-chain','stance','sayhuri'],
 ['sentinel',null,'melee-chain','parry-riposte','sentinel'],
 ['sentinel-builder',null,'burst-melee','forge-turret','sentinel-builder'],
 ['alien-commander',null,'projectile','command','alien-commander'],
 ['quantum-archmage',null,'projectile','phase-shift','quantum-archmage'],
 ['wisp-warden',null,'projectile','swarm','wisp-warden'],
 ['elyon-protagonist',null,'melee-chain','dash-strike','elyon-protagonist'],
 ['jhadson-first-light',null,'melee-chain','burst','jhadson-first-light'],
 ['celestial-angel',null,'melee-chain','heal','celestial-angel'],
 ['guardian-knight-v2',null,'melee-chain','shockwave','guardian-knight-v2'],
 ['shatterkin',null,'melee-chain','shockwave','shatterkin'],
 ['tidebound',null,'projectile','phase-shift','tidebound'],
 ['warden','warden','melee-chain','dash-strike','warden'],
 ['vaelthar-astral-architect',null,'projectile','phase-shift','vaelthar-astral-architect'],
] as const

const ATTACK_PATTERN_DNA:Record<string,CharacterDNAPatch>={
 'melee-chain':{
  combat:{preferredRange:.36,tempo:.62,pressure:.68,comboPersistence:.8,pursuit:.7},
  expression:{cadence:.64,motionWeight:.58,telegraph:.56},
 },
 'burst-melee':{
  combat:{preferredRange:.28,tempo:.9,pressure:.84,comboPersistence:.92,pursuit:.88,feintBias:.72},
  expression:{cadence:.92,motionWeight:.4,grace:.76,telegraph:.38},
 },
 projectile:{
  combat:{preferredRange:.84,tempo:.56,pressure:.46,resourceConservation:.72,environmentUse:.74,retreatDiscipline:.7},
  mind:{precision:.8,caution:.64,prediction:.7},
  expression:{cadence:.54,telegraph:.68,motionWeight:.42},
 },
}

const SPECIAL_DNA:Record<string,CharacterDNAPatch>={
 shockwave:{combat:{pressure:.86,environmentUse:.82,specialBias:.88},power:{amplitude:.86,area:.9,environmentCoupling:.86},expression:{motionWeight:.82,ferocity:.78}},
 'plague-burst':{combat:{specialBias:.94,environmentUse:.88,resourceConservation:.62},power:{amplitude:.84,area:.9,volatility:.82,environmentCoupling:.88},expression:{aura:.9,telegraph:.62}},
 'echo-chain':{combat:{tempo:.96,comboPersistence:.98,pursuit:.92,specialBias:.88},mind:{creativity:.82,adaptability:.86},expression:{cadence:.96,grace:.9,secondaryMotion:.86}},
 'dash-strike':{combat:{pursuit:.9,finisherDiscipline:.78,counterBias:.7,specialBias:.8},mind:{precision:.8,courage:.76},power:{precision:.8},expression:{grace:.8,cadence:.82}},
 'phase-shift':{combat:{counterBias:.86,feintBias:.94,retreatDiscipline:.82,specialBias:.9},mind:{prediction:.84,adaptability:.9},power:{control:.84,transformation:.9},expression:{asymmetry:.9,telegraph:.3}},
 blink:{combat:{counterBias:.8,feintBias:.9,pursuit:.82,specialBias:.84},mind:{prediction:.78,adaptability:.88},power:{control:.8,precision:.86},expression:{asymmetry:.86,grace:.86,telegraph:.28}},
 summon:{combat:{environmentUse:.9,resourceConservation:.78,specialBias:.9},mind:{patience:.8,creativity:.86},power:{channeling:.92,area:.82,control:.8},expression:{aura:.84,telegraph:.78}},
 'death-mark':{combat:{finisherDiscipline:.98,counterBias:.86,specialBias:.94,pursuit:.88},mind:{prediction:.9,patience:.8,precision:.9},power:{precision:.94},expression:{telegraph:.24,ferocity:.88}},
 'rift-anchor':{combat:{environmentUse:.94,counterBias:.82,specialBias:.94,preferredRange:.8},mind:{prediction:.9,creativity:.86},power:{control:.94,area:.86,channeling:.88,environmentCoupling:.9},expression:{aura:.9,telegraph:.7}},
 'stance-shift':{combat:{counterBias:.84,guardBias:.82,resourceConservation:.86,specialBias:.76},mind:{adaptability:.96,discipline:.86},power:{control:.84},expression:{restraint:.82,cadence:.62}},
 'time-anchor':{combat:{environmentUse:.9,counterBias:.88,specialBias:.94,preferredRange:.78},mind:{prediction:.98,patience:.86},power:{control:.96,area:.82,channeling:.9},expression:{aura:.86,telegraph:.72}},
 'parry-riposte':{combat:{counterBias:.98,guardBias:.9,finisherDiscipline:.8,specialBias:.74},mind:{prediction:.94,discipline:.9,precision:.88},expression:{restraint:.9,telegraph:.42}},
 'forge-turret':{combat:{environmentUse:.96,resourceConservation:.86,preferredRange:.78,specialBias:.9},mind:{creativity:.9,discipline:.82},power:{channeling:.88,area:.78,control:.88},expression:{telegraph:.76}},
 command:{combat:{environmentUse:.94,resourceConservation:.84,specialBias:.86},mind:{discipline:.92,prediction:.84,drives:{protection:.82,dominance:.8}},power:{control:.9,area:.76},expression:{cameraPresence:.82,telegraph:.74}},
 swarm:{combat:{environmentUse:.92,pressure:.82,specialBias:.92},mind:{creativity:.9,adaptability:.86},power:{area:.9,channeling:.84,volatility:.74},expression:{secondaryMotion:.96,aura:.84}},
 burst:{combat:{tempo:.86,pressure:.78,specialBias:.86},mind:{courage:.84,precision:.8},power:{amplitude:.84,precision:.82},expression:{aura:.82,cameraPresence:.8}},
 heal:{combat:{resourceConservation:.94,guardBias:.78,specialBias:.72},mind:{discipline:.84,drives:{protection:.98,restraint:.86}},power:{recovery:.98,control:.92,area:.7},expression:{grace:.86,aura:.9,restraint:.9}},
 stance:{combat:{counterBias:.8,guardBias:.78,resourceConservation:.84},mind:{adaptability:.9,discipline:.84},power:{control:.8},expression:{restraint:.82}},
}

function mergeSemanticPatch(attackPatternId:string,specialAbilityId:string):CharacterDNAPatch{
 const attack=ATTACK_PATTERN_DNA[attackPatternId]??{},special=SPECIAL_DNA[specialAbilityId]??{}
 return{
  physiology:{...attack.physiology,...special.physiology},
  senses:{...attack.senses,...special.senses},
  mind:{...attack.mind,...special.mind,drives:{...attack.mind?.drives,...special.mind?.drives}},
  combat:{...attack.combat,...special.combat},
  power:{...attack.power,...special.power},
  expression:{...attack.expression,...special.expression},
  learning:{...attack.learning,...special.learning},
  capabilities:{
   ...attack.capabilities,...special.capabilities,
   attacks:{...attack.capabilities?.attacks,...special.capabilities?.attacks},
  },
 }
}

const BATTLE_ARENA_SEMANTIC_CONTRIBUTIONS:CharacterDNAContribution[]=BATTLE_ARENA_IDENTITY_ROWS.map(
 ([fighterId,,attackPatternId,specialAbilityId])=>({
  id:'battle-arena-semantic-kit-'+fighterId,
  source:BATTLE_ARENA_IDENTITY_SOURCE+'#semantic-kit',
  fighterId,
  priority:60,
  patch:mergeSemanticPatch(attackPatternId,specialAbilityId),
 })
)

const BATTLE_ARENA_IDENTITY_CONTRIBUTIONS:CharacterDNAContribution[]=BATTLE_ARENA_IDENTITY_ROWS.map(
 ([fighterId,animationDnaId,attackPatternId,specialAbilityId,modelAssetId])=>({
  id:'battle-arena-identity-'+fighterId,
  source:BATTLE_ARENA_IDENTITY_SOURCE,
  fighterId,
  priority:50,
  patch:{links:{
   animationDnaId,
   attackPatternId,
   specialAbilityId,
   modelAssetId,
   sourceRegistry:'portal-battle-arena/HeroRegistry',
  }},
 })
)

export const CHARACTER_DNA_CONTRIBUTIONS:readonly CharacterDNAContribution[]=[
 ...BATTLE_ARENA_IDENTITY_CONTRIBUTIONS,
 ...BATTLE_ARENA_SEMANTIC_CONTRIBUTIONS,
 ...CORE_CHARACTER_DNA_CONTRIBUTIONS,
]

